<!--
 * @Author: zhangshengwei
-->
<!--
 * @Author: zhangshengwei
-->
<!--
 * @Author: zhangshengwei
-->
<template>
  <div class="header_panel">
    <div class="header_top" v-if="showPosition">
      <div style="display: flex; align-items: center">
        <div style="display: flex; align-items: flex-end">
          <img src="@/assets/images/common/icon_add.png" class="header_icon" />
          <span style="color: #ffffff; font-size: 2vh; margin-left: 5px"
            >统计维度：</span
          >
        </div>
        <el-popover
          trigger="hover"
          v-model="showPopover"
          :disabled="!regionList || regionList.length <= 1"
          :hide-after="0"
          placement="bottom"
          popper-class="tooltip_popper"
        >
          <div class="select" slot="reference">
            <div>
              <span
                class="val"
                style="font-size: 2vh; color: #ffffff; cursor: pointer"
              >
                <span
                  class="area_name"
                  v-for="(v, i) in resetAreaName()"
                  :key="i"
                  >{{ v }}</span
                >
                <img
                  src="@/assets/img/common/select.png"
                  v-if="regionList && regionList.length > 1"
                  class="triangular_icon"
                  :class="showPopover ? 'rotate' : ''"
                />
              </span>
            </div>
          </div>
          <el-tree
            v-if="regionList && regionList.length > 0"
            class="address_tree"
            node-key="areaCode"
            :data="regionList"
            :props="defaultProps"
            @node-click="handleNodeClick"
          >
            <div class="custom-tree-node" slot-scope="{ data }">
              <span :class="data.disabled ? 'disabled' : ''">{{
                data.areaName
              }}</span>
              <div v-if="data.disabled" class="tree_disabled" @click.stop></div>
            </div>
          </el-tree>
        </el-popover>
      </div>
    </div>
    <div v-else class="empty-div">
      <span style="display: none" v-for="(v, i) in resetAreaName()" :key="i">{{
        v
      }}</span>
    </div>
    <div class="header_bottom">
      <div class="title">{{ largeScreenName || "农机智能驾驶舱" }}</div>
      <div class="time_panel">
        <span class="day time_font">{{ cloak.date }}</span>
        <span class="week time_font">{{ week }}</span>
        <span class="time time_font">{{ cloak.time }}</span>
      </div>
    </div>
    <img
      class="left_animation"
      src="@/assets/images/common/image_arrow_l.png"
    />
    <img
      class="right_animation"
      src="@/assets/images/common/image_arrow_r.png"
    />
    <div class="wather_panel" v-if="weatherData && weatherData.length > 0">
      <el-tooltip
        :hide-after="0"
        placement="bottom"
        popper-class="tooltip_popper"
      >
        <div
          class="item"
          style="cursor: pointer"
          v-for="(v, i) in weatherData"
          :key="i"
          v-show="i == 0"
        >
          <div class="time">
            {{ v.date ? parseTime(v.date, "{m}月{d}日") : "" }}&nbsp;&nbsp;{{
              i == 0 ? "今天" : i == 1 ? "明天" : getWeek(v.date)
            }}
          </div>
          <div class="wather">
            <div class="wather_icon">
              <span class="icon iconfont" :class="v.icon"></span>
            </div>
            <div class="info">
              <div class="status">
                {{ v.text_day || "--"
                }}<span v-if="v.text_night != v.text_day"
                  >~{{ v.text_night || "--" }}</span
                >
              </div>
              <div class="temperature">
                {{ v.low + "℃" || "--" }}~{{ v.high + "℃" || "--" }}
              </div>
            </div>
          </div>
        </div>
        <div
          slot="content"
          class="tooltip_wather_panel"
          v-if="weatherData && weatherData.length > 0"
        >
          <div
            class="item"
            v-for="(v, i) in weatherData"
            :key="i"
            v-show="i == 1 || i == 2"
          >
            <div class="time">
              {{ v.date ? parseTime(v.date, "{m}月{d}日") : "" }}&nbsp;&nbsp;{{
                i == 0 ? "今天" : i == 1 ? "明天" : getWeek(v.date)
              }}
            </div>
            <div class="wather">
              <div class="wather_icon">
                <span class="icon iconfont" :class="v.icon"></span>
              </div>
              <div class="info">
                <div class="status">
                  {{ v.text_day || "--"
                  }}<span v-if="v.text_night != v.text_day"
                    >~{{ v.text_night || "--" }}</span
                  >
                </div>
                <div class="temperature">
                  {{ v.low + "℃" || "--" }}~{{ v.high + "℃" || "--" }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-tooltip>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import * as homeApi from "@/api/home";
import { getAreaPermissions as GetAreaPermissionsApi } from "@/api/login.js";
import { mapGetters } from "vuex";
import { parseTime, getUrlParam } from "@/utils/index";
import { getWeatherData } from "@/utils/weather";
export default {
  inject: ["reload"],
  computed: {
    ...mapGetters(["getactiveRegionObj"]),
  },
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal && newVal.path) {
          this.pathName = newVal.path;
          if (this.pathName == "/home") {
            this.getScreenName("vehicleCreenNameList");
          } else if (this.pathName == "/work_info") {
            this.getScreenName("jobCreenNameList");
          } else if (this.pathName == "/new_cooperative") {
            this.getScreenName("cooperationCreenNameList");
          } else if (this.pathName == "/aiDispatch") {
            this.getScreenName("dispatchScreenNameList");
          } else if (this.pathName.indexOf("/governmentAffairs") >= 0) {
            console.log(this.getScreenName("governmentCreenNameList"));
            this.getScreenName("governmentCreenNameList");
          } else if (this.pathName == "/socialization") {
            this.getScreenName("socializationCreenNameList");
          } else {
            this.getScreenName("vehicleCreenNameList");
          }
        }
      },
    },
    getactiveRegionObj: {
      handler() {
        this.getAreaPermissions();
        if (this.pathName == "/home") {
          this.getScreenName("vehicleCreenNameList");
        } else if (this.pathName == "/work_info") {
          this.getScreenName("jobCreenNameList");
        } else if (this.pathName == "/new_cooperative") {
          this.getScreenName("cooperationCreenNameList");
        } else if (this.pathName == "/aiDispatch") {
          this.getScreenName("dispatchScreenNameList");
        } else if (this.pathName.includes("/governmentAffairs")) {
          this.getScreenName("governmentCreenNameList");
        } else if (this.pathName == "/socialization") {
          this.getScreenName("socializationCreenNameList");
        } else {
          this.getScreenName("vehicleCreenNameList");
        }
        // this.getLargeScreenName();
        this.getNoShowPosition();
      },
      deep: true,
    },
    // largeScreenNameList: {
    //   handler() {
    //     this.getLargeScreenName();
    //   },
    //   deep: true
    // },
    noShowPositionList: {
      handler() {
        this.getNoShowPosition();
      },
      deep: true,
    },
  },
  data() {
    return {
      largeScreenName: "",
      largeScreenNameList: [],
      showPosition: "false",
      // 大屏不展示区域位置字典
      noShowPositionList: [],
      parseTime,
      currentMenu: 1,
      timer: null,
      regionList: [],
      week: "",
      cloak: {
        time: "",
        date: "",
      },
      // 天气数据
      weatherData: [],
      curentAddress: null,
      // 地址树状图配置
      defaultProps: {
        children: "children",
        label: (data, node) => {
          let addressArr = data.areaName.split(",");
          return addressArr.slice(-1).join("") || "--";
        },
        isLeaf: (data, node) => {
          return !data.children;
        },
        disabled: (data, node) => {
          return data.disabled || true;
        },
      },
      showPopover: false,
      pathName: "/home",
      headerList: [
        {
          typeName: "large_screen_vehicle",
          listName: "vehicleCreenNameList",
        },
        {
          typeName: "large_screen_job",
          listName: "jobCreenNameList",
        },
        {
          typeName: "large_screen_cooperation",
          listName: "cooperationCreenNameList",
        },
        {
          typeName: "large_screen_dispatch",
          listName: "dispatchScreenNameList",
        },
        {
          typeName: "large_screen_government",
          listName: "governmentCreenNameList",
        },
        {
          typeName: "large_screen_socialization",
          listName: "socializationCreenNameList",
        },
      ],
      vehicleCreenNameList: [],
      jobCreenNameList: [],
      cooperationCreenNameList: [],
      dispatchScreenNameList: [],
      governmentCreenNameList: [],
      socializationCreenNameList: [],
    };
  },
  created() {
    this.week = this.getWeek();
    this.run();
    // this.getLargeScreenDictList();
    this.getNoShowPositionList();
    this.headerList.forEach((item) => {
      this.getLargeScreenNameDictList(item.typeName, item.listName);
    });
  },
  mounted() {
    this.getUserArea();
    this.getWeatherData();
    let curentInfo = getUrlParam("curentAddress");
    let addressInfo = curentInfo
      ? JSON.parse(decodeURIComponent(curentInfo))
      : null;
    this.curentAddress = addressInfo
      ? addressInfo
      : sessionStorage.getItem("curentAddress")
      ? JSON.parse(sessionStorage.getItem("curentAddress"))
      : null;
    console.log("this.curentAddress :>> ", this.curentAddress);
    if (this.curentAddress)
      sessionStorage.setItem(
        "curentAddress",
        JSON.stringify(this.curentAddress)
      );
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    getAreaPermissions() {
      let self = this;
      const areaId =
        self.getactiveRegionObj && self.getactiveRegionObj.areaCode;
      self.$store.commit("SET_DV_PERMISSIONS_READY", false);
      GetAreaPermissionsApi(areaId)
        .then((res) => {
          console.log("%c大屏权限.res", "color:#C0C", areaId, res);
          self.$store.commit("SET_DV_PERMISSIONS", res);
        })
        .catch((res) => {
          console.error("%c大屏权限获取失败", "color:#C0C", areaId, res);
        })
        .finally((res) => {
          self.$store.commit("SET_DV_PERMISSIONS_READY", true);
        });
    },
    /** 获取大屏名称 */
    getLargeScreenName() {
      let findData =
        this.largeScreenNameList && this.largeScreenNameList.length > 0
          ? this.largeScreenNameList.find((v) => {
              return v.dictLabel == this.getactiveRegionObj.areaCode;
            })
          : null;
      this.largeScreenName = findData ? findData.dictValue : "农机智能驾驶舱";
    },
    /** 获取大屏字典数据 */
    getLargeScreenDictList() {
      homeApi.getDictData("large_screen_name").then((res) => {
        this.largeScreenNameList = res || [];
      });
    },
    /** 获取大屏名称 */
    getScreenName(listName) {
      let findData =
        this[listName] && this[listName].length > 0
          ? this[listName].find((v) => {
              return v.dictLabel == this.getactiveRegionObj.areaCode;
            })
          : null;
      this.largeScreenName = findData ? findData.dictValue : "农机智能驾驶舱";
    },
    /** 获取大屏头部名字列表 */
    getLargeScreenNameDictList(typeName, listName) {
      console.log("------------", typeName);
      homeApi.getDictData(typeName).then((res) => {
        console.log("getLargeScreenNameDictList", typeName, res);
        this.$set(this, listName, res || []);
      });
    },
    /** 获取大屏是否展示省市区县 */
    getNoShowPosition() {
      let findData =
        this.noShowPositionList && this.noShowPositionList.length > 0
          ? this.noShowPositionList.find((v) => {
              return v.dictLabel == this.getactiveRegionObj.areaCode;
            })
          : null;
      this.showPosition = findData && findData.dictValue ? false : true;
    },
    /** 获取大屏字典数据 */
    getNoShowPositionList() {
      homeApi.getDictData("large_screen_no_show_position").then((res) => {
        this.noShowPositionList = res || [];
      });
    },
    resetAreaName() {
      if (this.getactiveRegionObj.areaName) {
        let areaNameArr = (
          this.getactiveRegionObj.wholeName || this.getactiveRegionObj.areaName
        )
          .split(",")
          .filter((v) => {
            return v != "中国";
          });
        // 保存倒数第二级地址名称
        this.$store.dispatch(
          "setLastPreAddreassName",
          areaNameArr.slice(-2, -1).join("")
        ); // 倒数第二个
        // 保存最后一级地址名称
        this.$store.dispatch(
          "setLastAddreassName",
          areaNameArr.slice(-1).join("")
        ); // 倒数第一个
        return areaNameArr;
      } else return [];
    },
    getUserArea() {
      homeApi.getUserArea().then((res) => {
        if (res && res.length > 0) {
          this.regionList = res.map((v) => {
            return Object.assign(v, {
              lastAreaName: this.resetOptionsAddressName(v.areaName),
              disabled: this.getAddressDisabled(v),
              children: !v.children
                ? []
                : v.children.map((vv) => {
                    return Object.assign(vv, {
                      lastAreaName: this.resetOptionsAddressName(vv.areaName),
                      disabled: this.getAddressDisabled(vv),
                    });
                  }),
            });
          });
          this.$store.dispatch(
            "setactiveRegionObj",
            this.curentAddress &&
              this.curentAddress != null &&
              this.curentAddress != "null"
              ? this.curentAddress
              : this.regionList[0]
          );
          localStorage.setItem("regionList", JSON.stringify(this.regionList));
        }
      });
    },
    /** 判断当前区域是否需要禁用 */
    getAddressDisabled(data) {
      if (data.url && data.url.indexOf(`${window.location.origin}`) >= 0)
        return true; // 地址为当前地址
      const county = data.areaCode.slice(4, 6); // 县
      if (county == "00") return false; // 当前不是县级，不禁用
      else if (!data.url) return true; // 当前县级且无跳转地址，禁用
      else return false; // 默认不禁用
    },
    run() {
      let self = this;
      this.timer = setInterval(function () {
        let cd = new Date();
        self.cloak.time =
          self.zeroPadding(cd.getHours(), 2) +
          ":" +
          self.zeroPadding(cd.getMinutes(), 2);
        self.cloak.date =
          self.zeroPadding(cd.getFullYear(), 4) +
          "." +
          self.zeroPadding(cd.getMonth() + 1, 2) +
          "." +
          self.zeroPadding(cd.getDate(), 2);
      }, 1000);
    },
    zeroPadding(num, digit) {
      let zero = "";
      for (let i = 0; i < digit; i++) {
        zero += "0";
      }
      return (zero + num).slice(-digit);
    },
    /** 获取天气信息 */
    getWeatherData() {
      // 调用需传入区域值，可参考https://easy-open-link.feishu.cn/wiki/wikcnXfeZ1lmUCbCSac2hYAEFb2
      // 101181330濮阳、101181503舞阳、101180203滑县、101180805兰考
      getWeatherData("101180805").then((res) => {
        this.weatherData = res.weatherData;
      });
    },
    /** 获取周 */
    getWeek(time = new Date()) {
      let now = new Date(time);
      let day = now.getDay();
      let weeks = new Array(
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      );
      return weeks[day];
    },
    /** 地址选择 */
    handleNodeClick(e) {
      let routePath = this.$route.path; // 县级应该跳转的路由权限字符
      let addressInfo = e;
      let token = sessionStorage.getItem("token")
        ? sessionStorage.getItem("token")
        : getUrlParam("token");
      console.info(
        "跳转信息",
        `${
          e.url
        }/#${routePath}?token=${token}&curentAddress=${encodeURIComponent(
          JSON.stringify(addressInfo)
        )}`
      );
      if (e.url) {
        window.location.href = `${
          e.url
        }/#${routePath}?token=${token}&curentAddress=${encodeURIComponent(
          JSON.stringify(addressInfo)
        )}`;
      } else console.error("暂无跳转地址", e);
    },
    resetOptionsAddressName(name = "") {
      let areaNameArr = name.split(",").filter((v) => {
        return v != "中国";
      });
      return areaNameArr.slice(-1).join("");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../../assets/css/base.css";
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}

.select {
  position: relative;
  .val {
    position: relative;
    display: flex;
    align-items: center;
    .area_name {
      margin-right: vw(10);

      &:nth-of-type(3) {
        margin-right: vw(26);
      }
    }
    .triangular_icon {
      position: absolute;
      right: 0;
      width: vw(15);
      height: vh(10);
      transition: all 300ms;
      &.rotate {
        transform: rotate(180deg);
        transition: all 300ms;
      }
    }
  }
}
.select:hover .city-list {
  position: absolute;
}
.city {
  height: 44px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid #024131;
}
.city-list {
  width: 186px;
  height: 186px;
  position: absolute;
  overflow: auto;
  background: #001e1b;
  z-index: 1000;
  left: 0%;
  padding: 0 20px;
  display: none;
}
.dot {
  width: 4px;
  height: 4px;
  background: #fff;
  display: inline-block;
  border-radius: 100%;
  margin-right: 10px;
}
.city-list::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.city-list::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 2px;
  background-color: #0dffa9;
  background-image: -webkit-linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.2) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0.2) 75%,
    transparent 75%,
    transparent
  );
}
.city-list::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #023f30;
  border-radius: 2px;
}
.left_animation,
.right_animation {
  width: vw(210);
  height: vw(61);
  position: absolute;
  left: vw(472);
  top: vh(20);
}
.right_animation {
  left: auto;
  right: vw(472);
}
.wather_panel,
.tooltip_wather_panel {
  pointer-events: all;
  position: absolute;
  right: vw(24);
  top: vh(12);
  display: flex;
  .item {
    display: flex;
    flex-direction: column;
    .time {
      font-size: fontSize(14);
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #20c792;
    }
    .wather {
      display: flex;
      .wather_icon {
        width: vw(30);
        height: vw(30);
        color: #20c792;
        font-size: fontSize(30);
        margin-right: vw(6);
        .icon {
          font-size: fontSize(30);
        }
      }
      .info {
        flex: 1;
        font-size: fontSize(14);
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #20c792;
        text-align: left;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
    }
  }
}
.tooltip_wather_panel {
  position: relative;
  right: 0;
  left: 0;
  top: 0;
  padding: vw(2) vw(8) !important;
  .item {
    &:nth-of-type(2) {
      margin-right: vw(30);
      position: relative;
      &:after {
        content: "";
        position: absolute;
        top: 0;
        bottom: 0;
        right: vw(-14.5);
        width: vw(1);
        background: #fff;
      }
    }
    .time {
      color: #fff;
    }
    .wather .wather_icon {
      color: #fff;
    }
    .wather .info {
      color: #fff;
    }
  }
}
.header_icon {
  height: vh(25);
  width: vw(21);
  margin-right: vw(4);
}
.empty-div {
  height: vh(60);
}
::v-deep.address_tree {
  width: vw(244);
  max-height: vh(300);
  overflow-y: auto;
  color: #fff;
  font-size: fontSize(16);
  background-color: inherit;
  /* 谷歌美化滚动条 */
  &::-webkit-scrollbar {
    width: vw(2);
    height: vw(2);
  }

  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0);
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(20, 187, 127, 1);
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(20, 187, 127, 1);
  }

  /* 火狐美化滚动条 */
  .el-dialog__body {
    scrollbar-color: #c8d2e0 #f3f4f9;
    /* 滑块颜色  滚动条背景颜色 */
    scrollbar-width: thin;
    /* 滚动条宽度有三种：thin、auto、none */
  }
  .el-tree-node:focus > .el-tree-node__content {
    background-color: inherit;
  }
  .el-tree-node {
    .el-tree-node__content {
      position: relative;
      height: vh(34);
      display: flex;
      align-items: center;
      &:hover,
      &:focus {
        background-color: #14bb7f;
      }
      .disabled {
        color: rgb(124, 152, 134);
      }
      .el-tree-node__expand-icon {
        width: vw(12);
        height: vh(10);
        background: url("../../../assets/images/common/icon_select_arrow_b.png")
          no-repeat center center;
        background-size: 75% 70%;
        margin-left: vw(10);
        margin-right: vw(10);
        transform: rotate(-90deg);
        &.expanded {
          transform: rotate(0deg);
        }
        &.is-leaf {
          opacity: 0;
        }
        &::before {
          content: none;
        }
      }
      .el-tree-node__label {
        font-size: fontSize(16);
      }
    }
  }
}
.tree_disabled {
  cursor: not-allowed;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
}
</style>
